import { Injectable } from '@angular/core';
import { Contactus } from 'app/interfaces/contactus';
import { BaseService } from './base.service';

@Injectable()
export class ContactService extends BaseService<Contactus>{
    rootUrl = "contactUs";
}